// Mock data for Enciso Landscape Services LLC

const ASSET_BASE = process.env.PUBLIC_URL || '';
const localAsset = (path) => `${ASSET_BASE}/assets/${path}`;

export const siteAssets = {
  aboutImage: localAsset('about-landscaping-team.png'),
  logo: localAsset('els-logo-white.jpg'),
};

export const companyInfo = {
  name: "Enciso Landscape Services",
  fullName: "Enciso Landscape Services, LLC",
  phone: "229-300-2085",
  email: "ernesto.landscapeservice@gmail.com",
  address: "905 Howell Rd, Valdosta, GA 31601",
  serviceArea: "Servicing Georgia & Florida",
  logo: siteAssets.logo,
  yearsExperience: 20,
};

export const aboutContent = {
  title: "About Enciso Landscape Services, LLC",
  description: `Enciso Landscape Services, LLC is a professional landscaping company with over 20 years of industry experience, providing reliable, high-quality services for both residential and commercial properties. Our team brings proven expertise, attention to detail, and a strong commitment to customer satisfaction on every job.

We offer a full range of landscaping services, including irrigation installation and repair, lawn care maintenance, planting, mulching, sod installation, and seasonal cleanups. We also specialize in residential hardscape design, landscape lighting, and effective drainage solutions to enhance the beauty and functionality of outdoor spaces.

From routine maintenance such as trimming, edging, and blowing to professional tree and shrub care, we focus on maintaining healthy landscapes that look great year-round.

At Enciso Landscape Services, LLC, we take pride in dependable service, clear communication, and quality workmanship. Whether managing a commercial property or improving a residential landscape, our goal is to deliver results you can trust and outdoor spaces you can be proud of.`,
};

export const heroSlides = [
  {
    id: 1,
    image: localAsset('hero-professional-landscaping.jpg'),
    title: "Professional Landscaping Services",
    subtitle: "Transform your outdoor space with over 20 years of expertise",
  },
  {
    id: 2,
    image: localAsset('hero-southern-landscapes.jpg'),
    title: "Beautiful Southern Landscapes",
    subtitle: "Creating stunning outdoor environments for Georgia & Florida homes",
  },
  {
    id: 3,
    image: localAsset('hero-commercial-residential.jpg'),
    title: "Commercial & Residential Excellence",
    subtitle: "Professional lawn care for properties of all sizes",
  },
];

export const services = [
  {
    id: "irrigation-install",
    title: "Irrigation Installation",
    shortDesc: "Professional sprinkler system design and installation",
    description: "Complete irrigation system design and installation for efficient watering of your landscape. We use quality materials and proven techniques to ensure optimal coverage and water conservation for Georgia and Florida properties.",
    icon: "Droplets",
    image: localAsset('service-irrigation-install.png'),
    gallery: [
      localAsset('service-irrigation-install.png'),
    ],
  },
  {
    id: "irrigation-repair",
    title: "Irrigation Repair",
    shortDesc: "Fast, reliable sprinkler system repairs",
    description: "Quick diagnosis and repair of broken sprinkler heads, leaks, controller issues, and valve problems. We keep your irrigation system running efficiently in the hot Southern climate.",
    icon: "Wrench",
    image: localAsset('service-irrigation-repair.png'),
    gallery: [
      localAsset('service-irrigation-repair.png'),
    ],
  },
  {
    id: "lawn-maintenance",
    title: "Lawn Care Maintenance",
    shortDesc: "Complete lawn care for a healthy, green yard",
    description: "Regular mowing, fertilization, weed control, and lawn health management to keep your St. Augustine, Bermuda, or Zoysia grass looking its best throughout the seasons.",
    icon: "Scissors",
    image: localAsset('service-lawn-maintenance.png'),
    gallery: [
      localAsset('service-lawn-maintenance.png'),
    ],
  },
  {
    id: "landscape-lighting",
    title: "Landscape Lighting",
    shortDesc: "Illuminate your outdoor spaces beautifully",
    description: "Professional outdoor lighting design and installation to enhance safety, security, and the beauty of your Southern property after dark.",
    icon: "Lightbulb",
    image: localAsset('service-landscape-lighting.png'),
    gallery: [
      localAsset('service-landscape-lighting.png'),
    ],
  },
  {
    id: "hardscape-design",
    title: "Hardscape Design",
    shortDesc: "Custom patios, walkways, and outdoor living spaces",
    description: "Transform your outdoor space with beautiful hardscape features including patios, walkways, retaining walls, and outdoor living areas perfect for the Georgia and Florida lifestyle.",
    icon: "LayoutGrid",
    image: localAsset('service-hardscape-design.jpg'),
    gallery: [
      localAsset('service-hardscape-design.jpg'),
    ],
  },
  {
    id: "planting",
    title: "Planting",
    shortDesc: "Expert plant selection and installation",
    description: "Professional planting services including palms, azaleas, camellias, ornamental grasses, and native plants selected specifically for the Georgia and Florida climate.",
    icon: "Flower2",
    image: localAsset('service-planting.png'),
    gallery: [
      localAsset('service-planting.png'),
    ],
  },
  {
    id: "mulching",
    title: "Mulching",
    shortDesc: "Quality mulch installation for healthier beds",
    description: "Professional mulch installation to improve soil health, retain moisture in the hot Southern summers, suppress weeds, and enhance the appearance of your garden beds.",
    icon: "Layers",
    image: localAsset('service-mulching.png'),
    gallery: [
      localAsset('service-mulching.png'),
    ],
  },
  {
    id: "sod-installation",
    title: "Sod Installation",
    shortDesc: "Instant lawn transformation with quality sod",
    description: "Transform bare or damaged areas into lush, green lawns instantly with our professional sod installation. We work with St. Augustine, Bermuda, Zoysia, and other Southern turf varieties.",
    icon: "Leaf",
    image: localAsset('service-sod-installation.png'),
    gallery: [
      localAsset('service-sod-installation.png'),
    ],
  },
  {
    id: "drainage-solutions",
    title: "Drainage Solutions",
    shortDesc: "Effective water management for your property",
    description: "Solve water drainage problems common in Georgia and Florida with French drains, channel drains, grading, and other solutions to protect your landscape and property from heavy rains.",
    icon: "Waves",
    image: localAsset('service-drainage-solutions.png'),
    gallery: [
      localAsset('service-drainage-solutions.png'),
    ],
  },
  {
    id: "seasonal-cleanups",
    title: "Seasonal Cleanups",
    shortDesc: "Complete seasonal property maintenance",
    description: "Prepare your property for each season with our comprehensive cleanup services including leaf removal, bed cleanup, pine straw refreshing, and debris clearing.",
    icon: "CalendarDays",
    image: localAsset('service-seasonal-cleanups.jpg'),
    gallery: [
      localAsset('service-seasonal-cleanups.jpg'),
    ],
  },
  {
    id: "tree-shrub-care",
    title: "Tree & Shrub Care",
    shortDesc: "Professional tree and shrub maintenance",
    description: "Complete tree and shrub care including pruning, disease treatment, fertilization, and palm tree maintenance to keep your Southern landscape healthy and beautiful.",
    icon: "TreePine",
    image: localAsset('service-tree-shrub-care.png'),
    gallery: [
      localAsset('service-tree-shrub-care.png'),
    ],
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    location: "Valdosta, GA",
    text: "Enciso Landscape Services transformed our backyard! Their attention to detail and professionalism exceeded our expectations.",
    rating: 5,
  },
  {
    id: 2,
    name: "Robert J.",
    location: "Tallahassee, FL",
    text: "We've used their lawn maintenance services for over a year now. Always reliable, always professional. Highly recommend!",
    rating: 5,
  },
  {
    id: 3,
    name: "Commercial Property Manager",
    location: "Albany, GA",
    text: "Outstanding commercial landscaping services. They keep our properties looking immaculate year-round.",
    rating: 5,
  },
];
